<template>
  <div class="select-container">
    <span class="label">{{ deviceType }}</span>
    <el-select
      class="select"
      v-model="activeDeviceId"
      :placeholder="deviceType"
      @change="handleChange"
    >
      <el-option
        v-for="item in deviceList"
        :key="item.deviceId"
        :label="item.label"
        :value="item.deviceId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>


export default {
  name: "compDeviceSelect",
  props: {
    deviceType: {
      type: String,
    },
  },
  data() {
    return {
      deviceList: ['切换摄像头'],
      activeDevice: {},
      activeDeviceId: "",
    };
  },
  methods: {
    async getDeviceList() {
      // switch (this.deviceType) {
      //   case "camera":
      //     this.deviceList = await TRTC.getCameras();
      //     break;
      //   case "microphone":
      //     this.deviceList = await TRTC.getMicrophones();
      //     break;
      //   case "speaker":
      //     this.deviceList = await TRTC.getSpeakers();
      //     break;
      //   default:
      //     break;
      // }
      // [this.activeDevice] = this.deviceList;
      // this.activeDeviceId = this.deviceList[0].deviceId;
      // this.$emit("change", this.activeDeviceId);
    },
    handleChange() {
      //  this.$trtcCalling.switchCamera();
      // this.$emit("change", this.activeDeviceId);
    //    let userID = this.$store.state.loginUserInfo.userId;
       
    //   this.localStream = TRTC.createStream({
    //     userID,
    //     audio: true,
    //     video: true,
    //   });
    //    this.localStream.switchDevice('video', this.activeDeviceId);
    //   this.localStream.switchDevice("video", this.activeDeviceId).then((res) => {
    //     this.$message.success("切换成功");
    //   });
    },
  },
  mounted() {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(() => {
        this.getDeviceList();
      });
    navigator.mediaDevices.addEventListener("devicechange", this.getDeviceList);
  },
  beforeDestroy() {
    navigator.mediaDevices.removeEventListener(
      "devicechange",
      this.getDeviceList
    );
  },
};
</script>

